// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"6661":"bb316c81c50a5d4c","7187":"5c3c494a79788e24","7458":"5677ad481e2285d6"}[chunkId] + ".css";
};